export const JavaScriptTasks = [
  {
    id: 'js-for-loop',
    categoryId: '3',
    title: 'for loop',
    code: `const myArray = [6, 19, 20]
const yourArray = [19, 81, 2]

for (let i = 0; i < myArray.length; i++) {
  for (let j = 0; j < yourArray.length; j++) {
    if (myArray[i] === yourArray[j]) {
      console.log('Both loops have the number: ' + yourArray[j])
    }
  }
}`,
    lang: 'js',
  },
  {
    id: 'js-do-while-loop',
    categoryId: '3',
    title: 'do...while',
    code: `let result = ''
let i = 0

do {
  i = i + 1
  result = result + i
} while (i < 5)

console.log(result)
// expected: '12345'`,
    lang: 'js',
  },
  {
    id: 'js-push',
    categoryId: '3',
    title: 'push',
    code: `const items = [
  { id: 111, name: 'Burger', price: 299 },
  { id: 222, name: 'Fries', price: 150 },
  { id: 333, name: 'Cola', price: 199 },
]

const newItem = { id: 4444, name: 'Hot dog', price: 99 }
items.push(newItem)`,
    lang: 'js',
  },
  {
    id: 'js-indexOf',
    categoryId: '3',
    title: 'indexOf',
    code: `const index = string.indexOf('h')

console.log(index) // -1

if (index >= 0) {
  console.log('exists')
} else {
  console.log('does not exists')
}
// output: does not exists`,
    lang: 'js',
  },
  {
    id: 'js-split',
    categoryId: '3',
    title: 'split',
    code: `const month = 'Jun, Jul, Aug'

const arr = month.split(', ', 2)

for (let i = 0; i < arr.length; i++) {
    console.log('Month: ' + arr[i])
}

// Month: Jun
// Month: Jul`,
    lang: 'js',
  },
  {
    id: 'js-curring',
    categoryId: '3',
    title: 'curring',
    code: `const sum = function (a, b) {
  return function (c) {
    return a + b + c
  }
}

sum(1, 2)(3) // 6`,
    lang: 'js',
  },
  {
    id: 'js-reduce',
    categoryId: '3',
    title: 'reduce',
    code: `const items = [
  { name: 'Burger', quantity: 2, price: 299 },
  { name: 'Fries', quantity: 5, price: 150 },
  { name: 'Cola', quantity: 1, price: 199 },
]

const sum = goods.reduce((accumulator, product) => {
  return accumulator + (product.quantity * product.price)
}, 0)`,
    lang: 'js',
  },
  {
    id: 'js-find',
    categoryId: '3',
    title: 'find',
    code: `const books = [
  { id: 0, title: 'Lord of the Rings' },
  { id: 1, title: 'Hobbit' },
]

const hobbitBook = books.find((book) => {
  return book.title === 'Hobbit'
})`,
    lang: 'js',
  },
  {
    id: 'js-destructuring',
    categoryId: '3',
    title: 'destructuring',
    code: `const user = {
  firstName: 'Brendan',
  info: {
    skills: ['html', 'css', 'pascal'],
  },
}

const {
  info: {
    skills: [html, css, pascal],
  },
} = user`,
    lang: 'js',
  },
  {
    id: 'js-class',
    categoryId: '3',
    title: 'class',
    code: `class Cart {
  static name = 'My cart'
  #items

  constructor(items = []) {
    this.#items = items
  }

  add(item) {
    const state = [...this.#items, item]
    this.#items = state
  }
}`,
    lang: 'js',
  },
  {
    id: 'js-recursion',
    categoryId: '3',
    title: 'recursion',
    code: `function factorial(x) {
  if (x === 0) {
    return 1
  } else {
    return x * factorial(x - 1)
  }
}

const num = 3
if (num > 0) {
  let result = factorial(num)
}`,
    lang: 'js',
  },
  {
    id: 'js-promise',
    categoryId: '3',
    title: 'promise',
    code: `const myPromise = new Promise((resolve, reject) => {
  if (2 + 2 === 3) {
    resolve('Success!')
  } else {
    reject({
      errorType: 'ArithmeticError',
      message: "The numbers don't add up!",
    })
  }
})`,
    lang: 'js',
  },
  {
    id: 'js-promise-chaining',
    categoryId: '3',
    title: 'promise chaining',
    code: `promise
  .then((message) => {
    console.log(\`Success: \${message}\`)
  })
  .catch((err) => {
    console.log(err.message)
  })
  .finally((message) => {
    console.log('Operations finished')
  })`,
    lang: 'js',
  },
  {
    id: 'js-promise-all',
    categoryId: '3',
    title: 'Promise.all()',
    code: `Promise.all([promiseA, promiseB])
  .then((values) => {
    console.log(\`Results from Promise.all(): [\${values}]\`)
  })
  .catch((err) => {
    console.log(\`Promise.all Failed! \${err.message}\`)
  })
  .finally(() => {
    console.log('Operations for Promise.all() have finished.')
  })`,
    lang: 'js',
  },
  {
    id: 'js-switch',
    categoryId: '3',
    title: 'switch',
    code: `switch (expression) {
  case 'Oranges':
    console.log('Oranges are $0.59 a pound.')
    break
  case 'Mangoes':
  case 'Papayas':
    console.log('Mangoes and papayas are $2.79 a pound.')
    break
  default:
    console.log(\`Sorry, we are out of \${expr}.\`)
}`,
    lang: 'js',
  },
]
